import { lazy } from "react";
const Home = lazy(() => import("@/modules/Dashboard"));

const HomeRoutes = {
  element: <Home />,
  path: "",
};

export default HomeRoutes;
